// extracted by mini-css-extract-plugin
export default {"icon":"cell_icon__375iR","mdCell":"cell_mdCell__LKK8w","smCell":"cell_smCell__D-9pa","xsmCell":"cell_xsmCell__CUo0w"};